import debounce from 'lodash.debounce';

export const getCityState = async (clientKey: string, zipcode: string) => {
  const url = `https://www.zipcodeapi.com/rest/${clientKey}/info.json/${zipcode}/radians`;

  const response = await fetch(url, { method: 'GET' });

  if (response.ok && response.status === 200) {
    return await response.json();
  } else {
    throw new Error(await response.json());
  }
};

export const debounced1s = debounce((fn) => fn(), 1000);
